import ConfirmationPopup from '@/components/popups/ConfirmationPopup'

export default {
  data() {
    return {
      copyWorkspaceRequest: false
    }
  },

  methods: {
    openCopyWorkspacePopup(workspace, version, workspaceName = '') {
      if (!this.canCalculate) {
        this.showCanCalculateNotification()
        return
      }

      if (this.checkWorkspaceVerisonLimitReached()) {
        return
      }

      this.$ui.popup
        .show({
          component: ConfirmationPopup,
          params: {
            title: 'Подтвердите создание копии рабочего пространства',
            html: `Будет создана полная копия рабочего пространства:<br/><b>[${workspace}] ${workspaceName} версия ${version}</b><br/><br/>Выполнить копирование?`,
            okText: 'Выполнить'
          }
        })
        .then((r) => {
          if (r === 'ok') {
            this.copyWorkspace(workspace, version)
          }
        })
    },

    copyWorkspace(workspace, version) {
      this.$store.dispatch('getModelingLimits').then((r) => {
        if (!this.canCalculate) {
          this.showCanCalculateNotification()
          return
        }
        if (!this.copyWorkspaceRequest) {
          this.copyWorkspaceRequest = true

          this.$store
            .dispatch('copyWorkspace', {
              workspace,
              version
            })
            .then(() => {
              this.copyWorkspaceRequest = false
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/copyWorkspace.js